import { render } from "./PlayerAudioControls.vue?vue&type=template&id=20f66432&scoped=true"
import script from "./PlayerAudioControls.vue?vue&type=script&lang=js"
export * from "./PlayerAudioControls.vue?vue&type=script&lang=js"

import "./PlayerAudioControls.vue?vue&type=style&index=0&id=20f66432&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f66432"]])

export default __exports__